import { Chip, ChipType, DirectionUpIcon } from '../../atoms';
import { useInvoiceRelatedClaimRequests } from '../../../application/Invoice/useInvoiceRelatedClaimRequests';
import RelatedClaimRequest from '../related-claim-request/RelatedClaimRequest';
import { useModuleTranslation } from '../../utils/useModuleTranslation';
import './DuplicatedInvoiceChip.modules.scss';

export type DuplicatedInvoiceChipProps = {
    taxIdNumber: string | undefined;
    number: string | undefined;
    date: Date | null | undefined;
    claimRequestKey?: string;
    label?: string;
    title?: string;
};

const DuplicatedInvoiceChip = ({
    taxIdNumber,
    number,
    date,
    claimRequestKey,
    label,
    title,
}: DuplicatedInvoiceChipProps) => {
    const { t } = useModuleTranslation();
    const { claimRequests } = useInvoiceRelatedClaimRequests(taxIdNumber, number, date);
    const claimsWithInvoiceDuplicated = claimRequests.filter((claimRequest) => claimRequest.key !== claimRequestKey);

    if (claimsWithInvoiceDuplicated.length === 0) {
        return null;
    }

    return (
        <RelatedClaimRequest
            title={title || t('invoice.duplicated.related_claims', 'Claims with duplicated invoices')}
            claimRequestsRelated={claimsWithInvoiceDuplicated}
            showUsages={false}
        >
            <Chip
                type={ChipType.ACTIONABLE}
                text={label || t('invoice.duplicated.description', 'Duplicated invoice')}
                icon={DirectionUpIcon}
                onClick={() => null}
                color={'orange'}
            />
        </RelatedClaimRequest>
    );
};

export default DuplicatedInvoiceChip;
